import { render, staticRenderFns } from "./FormBuy.vue?vue&type=template&id=5b0e70be&scoped=true&"
import script from "./FormBuy.vue?vue&type=script&lang=js&"
export * from "./FormBuy.vue?vue&type=script&lang=js&"
import style0 from "./FormBuy.vue?vue&type=style&index=0&id=5b0e70be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e70be",
  null
  
)

export default component.exports